import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import { trackPageView } from '@snowplow/browser-tracker'
import { TemplateActionNames } from '../consts/defaultConfigValues/defaultConstants'
import { ITemplate, ITemplateActions } from '../interfaces/templates'
import Default from './Default'
import useCategoryFilters from '../hooks/catalog/useCategoryFilters'
import { useFetchProducts } from '../hooks'
import type { IGenericFunction } from '../interfaces'
import useCloseGlobalPromotion from '../hooks/catalog/useCloseGlobalPromotion'

const Category: FC<ITemplate> = ({ ...props }) => {
  const { updateCategory } = useCategoryFilters()
  const fetchProducts = useFetchProducts()
  const closeGlobalPromotions = useCloseGlobalPromotion()

  const templateActions: ITemplateActions = {
    [TemplateActionNames.CATALOG_UPDATE_CATEGORY]:
      updateCategory as IGenericFunction,
    [TemplateActionNames.CATEGORY_FETCH_PRODUCTS]: fetchProducts,
    [TemplateActionNames.CLOSE_GLOBAL_PROMOTIONS_ALERT]:
      closeGlobalPromotions as IGenericFunction,
  }
  useEffect(() => {
    trackPageView({ title: props.container.uid })
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])
  return <Default templateActions={templateActions} {...props} />
}

export default Category
